(() => {
  const routes=['accueil','pierres','tarifs','commander','maison','certification','guide','contact','mentions','qualite'];
  const root=(document.body.dataset.chRoot || '/').replace(/\/?$/, '/');
  window.chPageUrl=(name)=>new URL(name==='accueil'?root:root+'pages/'+name,location.origin);
  function legacy(){
    const match=location.hash.match(/^#\/([a-z]+)(?:\?(.*))?$/);
    if(!match || !routes.includes(match[1]))return;
    const target=chPageUrl(match[1]);
    for(const key of ['preview_theme_id','pb'])if(new URLSearchParams(location.search).has(key))target.searchParams.set(key,new URLSearchParams(location.search).get(key));
    const old=new URLSearchParams(match[2] || '');
    if(old.get('panier')==='1')target.searchParams.set('panier','1');
    if(target.pathname===location.pathname){history.replaceState(null,'',target.pathname+target.search);return;}
    location.replace(target.href);
  }
  legacy();
  addEventListener('hashchange',legacy);
  const preview=new URLSearchParams(location.search).get('preview_theme_id');
  if(preview && /^\d+$/.test(preview))document.querySelectorAll('a[href]').forEach(a=>{
    if(a.getAttribute('href').startsWith('#'))return;
    const url=new URL(a.href,location.href);
    if(url.origin===location.origin && (url.pathname===root || url.pathname.startsWith(root+'pages/') || url.pathname.startsWith(root+'blogs/'))){url.searchParams.set('preview_theme_id',preview);a.href=url.pathname+url.search+url.hash;}
  });
})();
